<template>
<div class="component" v-if="isActive">

    <div class="modal is-active">
        <div class="modal-background" @click="closeModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p v-if="user!=null" class="modal-card-title">Benutzer bearbeiten</p>
                <p v-else class="modal-card-title">Benutzer hinzufügen</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
            </header>
            <section class="modal-card-body">

                <div class="userInputBody">
                    <label class="label">Vorname</label>

                    <input class="input" type="text" placeholder="Vorname" v-model="userName">
                    <label class="label">Nachname</label>

                    <input class="input" type="text" placeholder="Nachname" v-model="userLastName">
                    <label class="label">E-Mail</label>

                    <input class="input" type="text" placeholder="E-Mail" v-model="userEmail">
                    <label class="label">Passwort</label>

                    <input class="input" type="password" placeholder="Passwort" v-model="userPassword">
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" v-if="user!=null" @click="saveUserEdits()">Bearbeitung speichern</button>

                <button v-else class="button is-success" @click="addUser()">Benutzer hinzufügen</button>
                <button class="button" @click="closeModal()">Abbrechen</button>
            </footer>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'NewProjectModal',
    props: ["isActive", "user"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            userName: "",
            userLastName: "",
            userEmail: "",
            userPassword: ""
        }
    },
    methods: {
        closeModal() {
            this.$emit("close")
        },
        addUser() {
            if (this.userName != "" && this.userLastName != "" && this.userEmail != "" && this.userPassword != "") {
                let newUser = {
                    "lastName": this.userLastName,
                    "name": this.userName,
                    "email": this.userEmail,
                    "password": this.userPassword,
                    "password_confirmation": this.userPassword
                }
                this.callApi("/user/create", "post", newUser).then(function (response) {
                    this.refresh();
                    this.closeModal();
                }.bind(this))
            }

        },
        saveUserEdits() {
            if (this.userName != "" && this.userLastName != "" && this.userEmail != "") {
                
                let newUser = {}
                if (this.userPassword != "") {
                     newUser = {
                         "id":this.user.id,
                        "lastName": this.userLastName,
                        "name": this.userName,
                        "email": this.userEmail,
                        "password": this.userPassword,
                        "password_confirmation": this.userPassword
                    }
                } else {
                     newUser = {
                         "id":this.user.id,
                        "lastName": this.userLastName,
                        "name": this.userName,
                        "email": this.userEmail,
                    }
                }

                this.callApi("/user/edit", "post", newUser).then(function (response) {
                    this.refresh();
                    this.closeModal();
                }.bind(this))
            }
        },

        refresh() {
            this.$emit("refresh")
        },
    },
    computed: {},
    watch: {
        isActive: function (val) {
            if (this.user != null && this.user.name != null) {
                this.userName = this.user.name;
                this.userLastName = this.user.lastName;
                this.userEmail = this.user.email;
            } else {
                this.userName = "";
                this.userLastName = "";
                this.userEmail = "";
                this.userPassword = "";
            }
        }
    }
}
</script>

<style scoped>

</style>
